import { useFetchAllLabels } from './hooks/useFetchAllLabels'

class LabelsService {
  api = {
    useFetchAll: useFetchAllLabels
  }
}

export const labelsService = new LabelsService()
